import {
  Action_SaveBanHang ,
  Action_SaveBanHangSuccess ,
  Action_SaveBanHangFailed ,
  Action_GetBanHangPrint,
  Action_GetBanHangPrintSuccess
} from "./actionTypes";

// Sự kiện lưu 
export const Index_SaveBanHang = (data) => ({
  type: Action_SaveBanHang,
  payload: data
});
export const Index_SaveBanHangSuccess = (data) => ({
  type: Action_SaveBanHangSuccess,
  payload: data,
});
export const Index_SaveBanHangFailed = (data) => ({
  type: Action_SaveBanHangFailed,
  payload: data,
});

export const Index_GetBanHangPrint = (data) => ({
  type: Action_GetBanHangPrint,
  payload: data
});
export const Index_GetBanHangPrintSuccess = (data) => ({
  type: Action_GetBanHangPrintSuccess,
  payload: data,
});

